import {
  Box,
  Button,
  CircularProgress,
  Collapse,
  Grid,
  Hidden,
  IconButton,
  makeStyles,
  Paper,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import clsx from "clsx";
import { useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import ArrowAnimationIcon from "src/components/Icon/ArrowAnimationIcon";
import { usePoolMonitoringContext } from "src/context/monitoring/poolMonitoringContext";
import { useProviderContext } from "src/ether-utils/context/providerContext";
import { getContractEditPool } from "src/hooks/useContractEditPool";
import useNotify from "src/hooks/useNotify";
import CollapseItem from "./CollapseItem";
const useStyle = makeStyles((theme) => ({
  paper: {
    padding: 0,
  },
  item: {
    borderRadius: "10px 10px 0px 0px",
    padding: "0.5rem 1.5rem 0.5rem 1.5rem",
  },
  activeItem: {
    backgroundColor: theme.palette.background.subPaper,
  },
  acceptedStatus: {
    fontWeight: "450",
    color: "#37CB00",
  },
  pendingStatus: {
    fontWeight: "450",
    color: theme.palette.text.disabled,
  },
  cancelStatus: {
    fontWeight: "450",
    color: "#EA4848",
  },
  executedStatus: {
    fontWeight: "450",
    color: theme.palette.primary.main,
  },
}));

export default function RequestRow({ request, setSelectedRequest, setIsDetail, ...props }) {
  const cls = useStyle();
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.only("xs"));
  const { wallet } = useProviderContext();
  const { fetchPoolData } = usePoolMonitoringContext();
  const { errorNotify, successNotify } = useNotify();
  const [isLoadingCancel, setLoadingCancel] = useState(false);
  const [isLoadingExecute, setLoadingExecute] = useState(false);
  const { pool } = useParams();
  const history = useHistory();

  const handleAction = async (e, type) => {
    e.stopPropagation();
    if (type === "execute") {
      setLoadingExecute(true);
      try {
        const EditPoolContract = getContractEditPool(wallet.signer);
        if (request.name == "batchInitReserve") {
          const _len = request.data[0].length;
          const _promise = await EditPoolContract.executeTransaction(request["transaction_id"], {
            gasLimit: 2000000 * Number(_len),
          });
          await _promise.wait();
        } else {
          const _promise = await EditPoolContract.executeTransaction(request["transaction_id"]);
          await _promise.wait();
        }
        fetchPoolData();
        successNotify("Transaction Successful");
        history.push(`/pool-monitoring/${pool}?action=pending`);
      } catch (error) {
        errorNotify(error.message);
        setLoadingExecute(false);
        return;
      }
      setLoadingCancel(false);
    } else if (type === "cancel") {
      setLoadingCancel(true);
      try {
        const EditPoolContract = getContractEditPool(wallet.signer);
        const _promise = await EditPoolContract.revokeConfirmation(request["transaction_id"]);
        await _promise.wait();
        fetchPoolData();
        successNotify("Transaction Successful");
        history.push(`/pool-monitoring/${pool}?action=pending`);
      } catch (error) {
        errorNotify(error.message);
        setLoadingCancel(false);
        return;
      }
      setLoadingCancel(false);
    }
  };

  function onRowClick() {
    if (matches) {
      setSelectedRequest(request);
      setIsDetail(true);
    } else {
      setOpen(!open);
    }
  }

  const statusStyling = () => {
    switch (request.status) {
      case "Accepted":
        return cls.acceptedStatus;
      case "Cancel":
        return cls.cancelStatus;
      case "Executed":
        return cls.executedStatus;
      case "Pending":
        return cls.pendingStatus;
      case "Failure":
        return cls.cancelStatus;
    }
  };

  return (
    <Box {...props} mb={2}>
      <Paper className={cls.paper}>
        <div onClick={() => onRowClick()} style={{ cursor: "pointer" }}>
          <Grid container className={clsx(cls.item, { [cls.activeItem]: open })}>
            <Grid item md={2} sm={1} xs={1}>
              <Box display="flex" justifyContent="flex-start" alignItems="center" height="100%">
                <Typography variant="body1" style={{ fontWeight: "450", width: "50%", textAlign: "center" }}>
                  {request["transaction_id"]}
                </Typography>
              </Box>
            </Grid>
            <Grid item md={5} xs={8}>
              <Box display="flex" justifyContent="flex-start" alignItems="center" height="100%">
                <Typography variant="body1" style={{ fontWeight: "450" }}>
                  {request["name"]
                    .replace(/([A-Z])/g, " $1")
                    .charAt(0)
                    .toUpperCase() + request["name"].replace(/([A-Z])/g, " $1").slice(1)}
                </Typography>
              </Box>
            </Grid>
            <Grid item md={2} sm={3} xs={3}>
              <Box display="flex" justifyContent="flex-start" alignItems="center" height="100%">
                <Typography variant="body2" className={statusStyling()}>
                  {request["status"]}
                </Typography>
              </Box>
            </Grid>
            <Hidden smDown>
              <Grid item md={2} sm={2} xs={1}>
                <Box display="flex" justifyContent="flex-start" alignItems="center" height="100%">
                  <Button
                    style={{ marginRight: 10, zIndex: 1000 }}
                    color="primary"
                    variant="outlined"
                    disabled={
                      (request.status !== "Accepted" && request.status !== "Pending" && request.status !== "Failure") ||
                      isLoadingCancel
                    }
                    onClick={(e) => handleAction(e, "cancel")}
                  >
                    {!isLoadingCancel ? "Cancel" : <CircularProgress size={24} />}
                  </Button>
                  <Button
                    color="primary"
                    variant="contained"
                    disabled={(request.status !== "Accepted" && request.status !== "Failure") || isLoadingExecute}
                    onClick={(e) => handleAction(e, "execute")}
                  >
                    {!isLoadingExecute ? "Execute" : <CircularProgress size={24} />}
                  </Button>
                </Box>
              </Grid>
            </Hidden>
            <Hidden smDown>
              <Grid item xs={1}>
                <Box display="flex" justifyContent="flex-end" alignItems="center" height="100%">
                  <IconButton edge="start" onClick={() => setOpen(!open)}>
                    <ArrowAnimationIcon color="primary" isTransform={open} />
                  </IconButton>
                </Box>
              </Grid>
            </Hidden>
          </Grid>
        </div>
        <Collapse in={open}>
          <CollapseItem request={request} />
        </Collapse>
      </Paper>
    </Box>
  );
}
